// Email validation
export function validateEmail(email: string): boolean {
  const regExp =
    /^[a-zA-Z0-9]([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  return regExp.test(String(email).toLowerCase());
}

// Name validation
export function validateName(name: string): boolean {
  const regExp = /^[가-힣a-zA-Z0-9][가-힣a-zA-Z0-9\s]{0,50}[가-힣a-zA-Z0-9]$/g;
  return regExp.test(String(name).toLowerCase());
}

// Password combination validation
export function validatePasswordCombination(password: string): boolean {
  const num = password.search(/[0-9]/g);
  const eng = password.search(/[a-z]/gi);
  const spe = password.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);

  if ((num < 0 && eng < 0) || (eng < 0 && spe < 0) || (spe < 0 && num < 0)) {
    return false;
  }
  return true;
}

// Password length validation
export function validatePasswordLength(password: string): boolean {
  const pw = password;
  if (pw.length < 10) {
    return false;
  }
  return true;
}

// Remove spaces from input
export function checkSpace(e: React.ChangeEvent<HTMLInputElement>): boolean {
  const space = /\s/;
  if (space.exec(e.target.value)) {
    e.target.value = e.target.value.replace(" ", "");
    return false;
  }
  return true;
}

// Format birthday input
export function checkBirthday(e: React.ChangeEvent<HTMLInputElement>): boolean {
  e.target.value = e.target.value.replace(/[^0-9]/g, "");
  e.target.value = e.target.value.replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
  return false;
}

// Format phone number input
export function checkPhone(e: React.ChangeEvent<HTMLInputElement>): boolean {
  e.target.value = e.target.value.replace(/[^0-9]/g, "");
  if (e.target.value.length === 11) {
    e.target.value = e.target.value.replace(
      /(\d{3})(\d{4})(\d{4})/g,
      "$1-$2-$3"
    );
  } else {
    e.target.value = e.target.value.replace(
      /(\d{3})(\d{3})(\d{4})/g,
      "$1-$2-$3"
    );
  }
  return false;
}
